const spaces: SpaceProps = {
  alpha: 8,
  beta: 12,
  gamma: 16,
  delta: 24,
  epsilon: 32,
  zeta: 40,
  eta: 48,
  theta: 56,
  'kappa-epsilon': 72,
  iota: 80,
  kappa: 104,
  lambda: 128,
};

export interface SpaceProps {
  [key: string]: number;
}

export default spaces;
